/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, FormControl, FormControlLabel, IconButton, makeStyles, Radio, RadioGroup, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
// import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { convertStringNumberToNumber, formatNumber, getLabels, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
// import { DrillDownType } from '../DrillDownType';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { SearchCriteria } from '../SearchCriteria';
import { DrillDownType } from '../DrillDownType';
import { ChartCommonState } from '../../leadsDashboard/Common';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { useScreenshot, createFileName } from 'use-react-screenshot';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MTooltip from '@material-ui/core/Tooltip';
import { ChartInfo } from '../../components/ChartInfo';
import { VideoModal } from '../../components/VideoModal';
import VideoLibraryOutlinedIcon from '@material-ui/icons/VideoLibraryOutlined';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvLegendLabels, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartEmptyState } from '../ChartEmptyState';
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            position: 'relative'
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        formControl: {
            display: 'flex',
            flexFlow: 'row wrap',
            alignItems: 'center',
            justifyContent: 'center',
        },
        formLabel: {
            marginRight: '10px',
        },
        scrollUp: {
            position: 'absolute',
            top: '30px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        scrollDown: {
            position: 'absolute',
            bottom: '90px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        learnIcon: {
            color: 'rgb(0, 120, 212)'
        }
    }),
);

export enum BillingOptionEnum {
    LAST_NINETY_DAYS,
    LAST_TWELVE_MONTHS,
    FINANCIAL_YEAR,
    PREV_FINANCIAL_YEAR,
    ALL,
}

interface ClientBillingChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    selectedOption?: BillingOptionEnum;
    infoUrl: string | null;
}

interface ChartState extends ChartCommonState {
    option: BillingOptionEnum;
    clientData: string[];
    feesBilledData: number[];
    previousFeesBilledData: number[];
    invoicesCountData: number[];
    totalBilling: number;
    symbol: string;
    periodString: string;
}

export const ClientBillingChart: React.FC<ClientBillingChartProps> = (props) => {
    const classes = useStyles();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const entireChartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollUpAndPrevRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollDownAndNextRef = React.useRef<any>();

    const [isVideoModalOpen, setIsVideoModalOpen] = useState<boolean>(false);

    // tslint:disable-next-line:no-any
    const { loading, error, data } = useQuery<ClientBillingData, ClientBillingParams>(ClientBillingQuery, {
        variables: {
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
            showAllRecords: props.showAllRecords
        },
    });

    const takeScreenShot = useScreenshot({
        type: 'image/jpeg',
        quality: 1.0
    })[1];

    // todo :
    const [state, setState] = useState<ChartState>({
        open: false,
        anchorEl: undefined,
        option: props.selectedOption === undefined ? BillingOptionEnum.LAST_NINETY_DAYS : props.selectedOption, // option
        clientData: [],
        feesBilledData: [],
        previousFeesBilledData: [],
        invoicesCountData: [],
        totalBilling: 0,
        symbol: '$',
        periodString: 'Last 90 Days',
    });

    const currencySymbolQuery = useQuery<CurrencySymbolData>(CURRENCY_SYMBOL_QUERY);

    useEffect(() => {
        if (currencySymbolQuery.data && currencySymbolQuery.data.options && !currencySymbolQuery.loading && !currencySymbolQuery.error) {
            setState((prevState) => {
                return {
                    ...prevState,
                    symbol: currencySymbolQuery.data!.options.currencySymbol.symbol,
                };
            });
        }

        // tslint:disable-next-line: align
    }, [currencySymbolQuery.loading, currencySymbolQuery.error, currencySymbolQuery.data]);

    useEffect(() => {
        window.addEventListener('keydown', onKeyDownHandler);

        return () => {
            window.removeEventListener('keydown', onKeyDownHandler);
        };
        // tslint:disable-next-line: align
    }, []);

    // tslint:disable-next-line:no-any
    const onKeyDownHandler = (event: any) => {
        if (event.keyCode === 80 && (event.ctrlKey || event.metaKey) && !event.altKey) {
            event.preventDefault();
            if (event.stopImmediatePropagation) {
                event.stopImmediatePropagation();
            } else {
                event.stopPropagation();
            }
            return;
        }
    };

    useEffect(() => {
        if (!loading) {
            setState((prevState) => {
                let clientData: string[] = [];
                let feesBilledData: number[] = [];
                let previousFeesBilledData: number[] = [];
                let invoicesCountData: number[] = [];
                let totalBilling = 0;

                let periodString: string = '';

                if (!error && data && data.statistics && data.statistics.fees) {
                    var lastNinetyDays = data.statistics.fees.clientBilling.clientBillingByLastNinetyDays;
                    var lastTwelveMonths = data.statistics.fees.clientBilling.clientBillingByLastTwelveMonths;
                    var ThisFinancialYear = data.statistics.fees.clientBilling.clientBillingByThisFinancialYear;
                    var PreviousFinancialYear = data.statistics.fees.clientBilling.clientBillingByPreviousFinancialYear;
                    var All = data.statistics.fees.clientBilling.clientBillingAll;

                    if (state.option === BillingOptionEnum.LAST_NINETY_DAYS) {
                        periodString = 'Last 90 Days';
                        clientData = lastNinetyDays.clientBillingByClient.map((clientBilling: ClientBillingByClient) => clientBilling.client);
                        feesBilledData = lastNinetyDays.clientBillingByClient
                                        .map((clientBilling: ClientBillingByClient) => clientBilling.feesBilled);
                        previousFeesBilledData = lastNinetyDays.clientBillingByClient.map((clientBilling: ClientBillingByClient) => clientBilling.previousFeesBilled);
                        invoicesCountData = lastNinetyDays.clientBillingByClient.map((clientBilling: ClientBillingByClient) => clientBilling.invoicesCount);
                        totalBilling = lastNinetyDays.totalBilling;
                    } else if (state.option === BillingOptionEnum.LAST_TWELVE_MONTHS) {
                        periodString = 'Last Year';
                        clientData = lastTwelveMonths.clientBillingByClient.map((clientBilling: ClientBillingByClient) => clientBilling.client);
                        feesBilledData = lastTwelveMonths.clientBillingByClient.map((clientBilling: ClientBillingByClient) => clientBilling.feesBilled);
                        previousFeesBilledData = lastTwelveMonths.clientBillingByClient
                                                .map((clientBilling: ClientBillingByClient) => clientBilling.previousFeesBilled);
                        invoicesCountData = lastTwelveMonths.clientBillingByClient.map((clientBilling: ClientBillingByClient) => clientBilling.invoicesCount);
                        totalBilling = lastTwelveMonths.totalBilling;
                    } else if (state.option === BillingOptionEnum.FINANCIAL_YEAR) {
                        periodString = 'Financial Year';
                        clientData = ThisFinancialYear.clientBillingByClient.map((clientBilling: ClientBillingByClient) => clientBilling.client);
                        feesBilledData = ThisFinancialYear.clientBillingByClient.map((clientBilling: ClientBillingByClient) => clientBilling.feesBilled);
                        previousFeesBilledData = ThisFinancialYear.clientBillingByClient
                                                .map((clientBilling: ClientBillingByClient) => clientBilling.previousFeesBilled);
                        invoicesCountData = ThisFinancialYear.clientBillingByClient.map((clientBilling: ClientBillingByClient) => clientBilling.invoicesCount);
                        totalBilling = ThisFinancialYear.totalBilling;
                    } else if (state.option === BillingOptionEnum.PREV_FINANCIAL_YEAR) {
                        periodString = 'Previous Financial Year';
                        clientData = PreviousFinancialYear.clientBillingByClient.map((clientBilling: ClientBillingByClient) => clientBilling.client);
                        feesBilledData = PreviousFinancialYear.clientBillingByClient.map((clientBilling: ClientBillingByClient) => clientBilling.feesBilled);
                        previousFeesBilledData = PreviousFinancialYear.clientBillingByClient
                                                .map((clientBilling: ClientBillingByClient) => clientBilling.previousFeesBilled);
                        invoicesCountData = PreviousFinancialYear.clientBillingByClient.map((clientBilling: ClientBillingByClient) => clientBilling.invoicesCount);
                        totalBilling = PreviousFinancialYear.totalBilling;
                    } else {
                        periodString = 'All';
                        clientData = All.clientBillingByClient.map((clientBilling: ClientBillingByClient) => clientBilling.client);
                        feesBilledData = All.clientBillingByClient.map((clientBilling: ClientBillingByClient) => clientBilling.feesBilled);
                        previousFeesBilledData = All.clientBillingByClient
                                                .map((clientBilling: ClientBillingByClient) => clientBilling.previousFeesBilled);
                        invoicesCountData = All.clientBillingByClient.map((clientBilling: ClientBillingByClient) => clientBilling.invoicesCount);
                        totalBilling = All.totalBilling;
                    }
                }

                return {
                    ...prevState,
                    periodString,
                    clientData,
                    feesBilledData,
                    previousFeesBilledData,
                    invoicesCountData,
                    totalBilling,
                };
            });
        }

        // tslint:disable-next-line: align
    }, [state.option, loading, error, data]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart(`isClientBillingChartOpen`);
        }
    };

    const handleTotalClick = () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            if (state.option === BillingOptionEnum.LAST_NINETY_DAYS) {
                searchCriterias.push(
                    { property: 'InvoicePeriod', operator: 'eq', comparison: 'LastNinetyDays' });
            } else if (state.option === BillingOptionEnum.LAST_TWELVE_MONTHS) {
                searchCriterias.push(
                    { property: 'InvoicePeriod', operator: 'eq', comparison: 'LastTwelveMonths' }
                );
            } else if (state.option === BillingOptionEnum.FINANCIAL_YEAR) {
                searchCriterias.push(
                    { property: 'InvoicePeriod', operator: 'eq', comparison: 'CurrentFinancialYear' });
            } else if (state.option === BillingOptionEnum.PREV_FINANCIAL_YEAR) {
                searchCriterias.push(
                    { property: 'InvoicePeriod', operator: 'eq', comparison: 'PrevFinancialYear' },
                    { property: 'StatusCode', operator: 'eq', comparison: 'B'}
                );
            } else {
                searchCriterias.push(
                    { property: 'InvoicePeriod', operator: 'eq', comparison: 'All' },
                    { property: 'StatusCode', operator: 'eq', comparison: 'B'}
                );
            }
            
            props.getSelectedItem(searchCriterias, false, `Drilldown from Client Billing - ${state.periodString}`, DrillDownType.invoiceSummary, 'Client Billing');
        }
    };

    const onChangeRadio = (name: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setState((prevState) => {
            return {
                ...prevState,
                // tslint:disable-next-line: radix
                [name]: parseInt((event.target as HTMLInputElement).value),
            };
        });
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };

    const onMaximize = () => {
        if (props.onMaximize) {
            props.onMaximize(state.option);
        }
    };

    const onScrollUpAndPrev = (type: 'up' | 'prev') => {
        if (chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min > 0) {
            const scrollRatio = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            const min = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            if (scrollRatio < chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min) {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= scrollRatio ? scrollRatio : 1; 
            } else {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= min;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= min;
            }
            chartRef.current.options.scales[type === 'up' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll up
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll up
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }
        scrollDownAndNextRef.current.classList.remove('Mui-disabled');
    };
    
    const onScrollDownAndNext = (type: 'down' | 'next') => {

        const labels = state.clientData;

        if (chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max < labels.length) {
            const remainingBar = labels.length - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max;
            const scrollRatio = chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min;
            if (remainingBar <= scrollRatio) {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += remainingBar;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += remainingBar;
            } else {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += scrollRatio ? scrollRatio : 1;
            }
            chartRef.current.options.scales[type === 'down' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll down
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll down
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
        scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
    };

    const onScollBar = (type: 'up' | 'down' | 'prev' | 'next') => () => {
        if (type === 'up') {
            onScrollUpAndPrev('up');
        } else if (type === 'down') {
            onScrollDownAndNext('down');
        }  else if (type === 'next') {
            onScrollDownAndNext('next');
        } else {
            onScrollUpAndPrev('prev');
        } 
    };

    const onDisabledEnabledArrow = (barType: 'horizontal' | 'vertical') => {  
        const labels = state.clientData;
        // up 
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].min > 0) {
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }

        // down
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].max < labels.length) {
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
    };
    
    const onZoom = (context: { chart: Chart }) => {

        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onPan = (context: { chart: Chart }) => {
        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    // tslint:disable-next-line: no-any
    const onContextMenu = (event: any) => {
        event.preventDefault();
        if (event.button !== 2) {
            return false;
        }
        return true;
    };

    const onToggleVideo = () => {
        setIsVideoModalOpen(!isVideoModalOpen);
    };

    // tslint:disable-next-line: no-any
    const onDownload = (name: string, extension: string = 'jpg') => (image: any) => {
        const a = document.createElement('a');
        a.href = image;
        a.download = createFileName(extension, name);
        a.click();
    };

    const onDownloadScreenshot = () => {
        setTimeout(() => {
            takeScreenShot(entireChartRef.current).then(onDownload('Client Billing'));
        // tslint:disable-next-line: align
        }, 500);
    };

    const chartControllerComponent = () => {
        return (
            <>
                <IconButtonWrapper aria-label="close">
                    <div
                        className={`${classes.helpIcon} rv-chart-help`} 
                    >
                        <ChartInfo 
                            description={props.description}
                            fontSize={props.showAllRecords ? 'large' : 'medium'}
                            // className={classes.helpIcon}
                        />
                        {props.infoUrl && (
                            <MTooltip title="Learn more">
                                <IconButton className={classes.learnIcon} aria-label="maximize" onClick={onToggleVideo} size={props.showAllRecords ? 'medium' : 'small'}>
                                    <VideoLibraryOutlinedIcon />
                                </IconButton>
                            </MTooltip>
                        )}
                    </div>
                    {props.showAllRecords && (
                        <IconButton size="medium" onClick={onDownloadScreenshot}>
                            <GetAppOutlinedIcon color="primary" fontSize="large" />
                        </IconButton>
                    )}
                    {!props.showAllRecords && props.onMaximize && (
                        <MTooltip title="Expand chart">
                            <IconButton aria-label="maximize" onClick={onMaximize} size="small">
                                <AspectRatioIcon />
                            </IconButton>
                        </MTooltip>
                    )}
                    <IconButton aria-label="close" onClick={onCloseChart} size={props.showAllRecords ? 'medium' : 'small'}>
                        <CloseIcon className={classes.closeIcon} fontSize={props.showAllRecords ? 'large' : 'medium'} />
                    </IconButton>
                </IconButtonWrapper>
            </>
        );
    };

    if (loading || currencySymbolQuery.loading) {
        return (
            <div className="rv-chart rv-chart-loading">
                {chartControllerComponent()}
                <ChartSkeleton variant="bars" />
            </div>
        );
    }
    
    return (
        <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(state.feesBilledData, state.previousFeesBilledData) ? ' rv-chart--empty' : ''}`} ref={entireChartRef}>
            {isVideoModalOpen && props.infoUrl && (
                <VideoModal 
                    open={isVideoModalOpen}
                    onClose={onToggleVideo}
                    url={props.infoUrl}
                />
            )}
            {chartControllerComponent()}
            <div className={classes.titleContainer}>
                <ChartHeading icon={<ReceiptOutlinedIcon />} title="Client Billing" />
                <div className={`${classes.total} h2`} onClick={handleTotalClick}>
                    <AnimatedNumber value={state.totalBilling} format={(amount) => `${state.symbol}${formatNumber(amount)}`} />
                </div>
            </div>
            <div className={classes.barContainer} style={{ maxHeight: props.showAllRecords ? '100%' : '350px' }}>
                {props.showAllRecords && (
                    <>
                        <div className={`${classes.scrollUp} scroll`}>
                            <IconButton 
                                size="medium" 
                                onClick={onScollBar('up')}
                                ref={scrollUpAndPrevRef}
                            >
                                <KeyboardArrowUpIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                        <div className={`${classes.scrollDown} scroll`}>
                            <IconButton 
                                size="medium" 
                                onClick={onScollBar('down')}
                                ref={scrollDownAndNextRef}
                            >
                                <KeyboardArrowDownIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                    </>
                )}
                <Bar
                    ref={chartRef}
                    onContextMenu={onContextMenu}
                    // tslint:disable-next-line: no-any
                    onClick={(event: React.MouseEvent<any>) => {
                        const _data = getElementAtEvent(chartRef.current, event);
                        if (_data.length > 0 && props.getSelectedItem) {
                            const _index = getElementAtEvent(chartRef.current, event)[0].index;

                            const item = state.clientData[_index];

                            const searchCriterias = new Array<SearchCriteria>();

                            if (state.option === BillingOptionEnum.LAST_NINETY_DAYS) {
                                searchCriterias.push(
                                    { property: 'InvoicePeriod', operator: 'eq', comparison: 'LastNinetyDays' });
                            } else if (state.option === BillingOptionEnum.LAST_TWELVE_MONTHS) {
                                searchCriterias.push(
                                    { property: 'InvoicePeriod', operator: 'eq', comparison: 'LastTwelveMonths' }
                                );
                            } else if (state.option === BillingOptionEnum.FINANCIAL_YEAR) {
                                searchCriterias.push(
                                    { property: 'InvoicePeriod', operator: 'eq', comparison: 'CurrentFinancialYear' },
                                );
                            } else if (state.option === BillingOptionEnum.PREV_FINANCIAL_YEAR) {
                                searchCriterias.push(
                                    { property: 'InvoicePeriod', operator: 'eq', comparison: 'PrevFinancialYear' },
                                );
                            } else {
                                searchCriterias.push(
                                    { property: 'InvoicePeriod', operator: 'eq', comparison: 'All' },
                                );
                            }

                            searchCriterias.push(
                                { property: 'Client', operator: 'eq', comparison: item === '(none)' ? 'NULL' : item }, //
                                { property: 'Status', operator: 'eq', comparison: 'Billed' }, //
                            );

                            props.getSelectedItem(
                                searchCriterias, 
                                true, 
                                'Drilldown from Client Billing - ' + item, 
                                DrillDownType.invoiceSummary, 
                                'Invoice'
                            );
                        }
                    }}
                    data={{
                        labels: getLabels(state.clientData),
                        datasets: [
                            {
                                label: 'Selected Period',
                                ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                data: state.feesBilledData,
                            },
                            {
                                label: 'Previous Period',
                                ...rvBarDatasetStyle(RV_CHART_COLORS.primarySoft),
                                data: state.previousFeesBilledData,
                            },
                        ],
                    }}
                    options={{
                        onHover: onHover,
                        indexAxis: 'y' as const,
                        animation: rvChartAnimation(),
                        elements: { bar: { borderWidth: 0 } },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                grid: rvValueAxisStyle.grid,
                                // beginAtZero: true,
                                suggestedMax: getSuggestedMaxTick(state.previousFeesBilledData),
                                beginAtZero: true,
                                ticks: {
                                    ...rvValueAxisStyle.ticks,
                                    maxTicksLimit: getMaxTickLimit(state.previousFeesBilledData),
                                    autoSkip: false,
                                    callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                        return `${state.symbol} ${formatNumber(tickValue)}`;
                                    },
                                },
                            },
                            y: {
                                grid: rvCategoryAxisStyle.grid,
                                min: 0,
                                max: props.showAllRecords ? 29 : 9,
                                ticks: {
                                    ...rvCategoryAxisStyle.ticks,
                                    autoSkip: false,
                                },
                            },
                        },
                        plugins: {
                            legend: {
                                position: 'bottom' as const,
                                display: true,
                                labels: rvLegendLabels,
                            },
                            title: {
                                display: false,
                                text: ``,
                            },
                            zoom: {
                                pan: {
                                    enabled: props.showAllRecords,
                                    onPan: onPan,
                                },
                                zoom: {
                                    wheel: {
                                        enabled: props.showAllRecords,
                                    },
                                    onZoom: onZoom,
                                },
                                // limits: {
                                //   y: { min: 0, max: 9 },
                                // },
                            },
                            tooltip: {
                                ...rvTooltipStyle,
                                callbacks: {
                                    // tslint:disable-next-line: no-any
                                    label: function (context: any) {
                                        const {
                                            // dataIndex,
                                            // label,
                                            formattedValue,
                                            dataset
                                        } = context;
                                        var currentValue = convertStringNumberToNumber(formattedValue);
                                        var callout = dataset.label === `Selected Period` ? `Service Fees` : `Previous Fees`;

                                        return `${callout}: ${state.symbol}${formatNumber(currentValue)}`;
                                    },
                                    // tslint:disable-next-line: no-any no-shadowed-variable
                                    afterLabel: function (context: any) {

                                        const {
                                              dataIndex,
                                            //   label,
                                            // formattedValue,
                                            dataset,
                                        } = context;

                                        const invoiceCount = state.invoicesCountData[dataIndex];

                                        if (dataset.label.toLowerCase() === 'previous period') {
                                            return [];
                                        }

                                        return [
                                            `Invoice Count: ${formatNumber(invoiceCount)}`,
                                        ];
                                    },
                                },
                            },
                        },
                    }}
                />
                {isChartDataEmpty(state.feesBilledData, state.previousFeesBilledData) && (
                    <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                )}
            </div>
            <FormControl component="div" className={classes.formControl}>
                <RadioGroup name="option" value={state.option} onChange={onChangeRadio('option')} className={classes.radioGroup}>
                    <FormControlLabel value={BillingOptionEnum.LAST_NINETY_DAYS} control={<Radio color="primary" />} label="Last 90 Days" />
                    <FormControlLabel value={BillingOptionEnum.LAST_TWELVE_MONTHS} control={<Radio color="primary" />} label="Last Year" />
                    <FormControlLabel value={BillingOptionEnum.FINANCIAL_YEAR} control={<Radio color="primary" />} label="Financial Year" />
                    <FormControlLabel value={BillingOptionEnum.PREV_FINANCIAL_YEAR} control={<Radio color="primary" />} label="Previous Financial Year" />
                    <FormControlLabel value={BillingOptionEnum.ALL} control={<Radio color="primary" />} label="All" />
                </RadioGroup>
            </FormControl>
        </div>
    );
};

export interface CurrencySymbolData {
    options: Options;
}

export interface Options {
    currencySymbol: CurrencySymbol;
}

export interface CurrencySymbol {
    symbol: string;
}

export const CURRENCY_SYMBOL_QUERY = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;

export interface ClientBillingParams {
    entityType?: number;
    entityGuid?: string;
    responsibility?: number;
    showAllRecords?: boolean;
}

export interface ClientBillingData {
    statistics: Statistics;
}

export interface Statistics {
    fees: Fees;
}

export interface Fees {
    clientBilling: ClientBilling;
}

export interface ClientBilling {
    clientBillingByLastNinetyDays: ClientBillingByPeriod;
    clientBillingByLastTwelveMonths: ClientBillingByPeriod;
    clientBillingByThisFinancialYear: ClientBillingByPeriod;
    clientBillingByPreviousFinancialYear: ClientBillingByPeriod;
    clientBillingAll: ClientBillingByPeriod;
}

export interface ClientBillingByPeriod {
    clientBillingByClient: ClientBillingByClient[];
    totalBilling: number;
}

export interface ClientBillingByClient {
    invoicesCount: number;
    client: string;
    feesBilled: number;
    previousFeesBilled: number;
}

const ClientBillingQuery = gql`
fragment ClientBillingByPeriodFragment on ClientBillingByPeriod {
    clientBillingByClient {
        feesBilled
        client
        invoicesCount
        previousFeesBilled
    }
    totalBilling
}

query clientBillingchart($entityType: Int, $entityGuid: String, $responsibility: Int, $showAllRecords: Boolean) {
    statistics {
        fees {
            clientBilling(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility, showAllRecords: $showAllRecords) {
                clientBillingByLastNinetyDays {
                    ...ClientBillingByPeriodFragment
                }
                clientBillingByLastTwelveMonths {
                    ...ClientBillingByPeriodFragment
                }
                clientBillingByThisFinancialYear {
                    ...ClientBillingByPeriodFragment
                }
                clientBillingByPreviousFinancialYear {
                    ...ClientBillingByPeriodFragment
                }
                clientBillingAll {
                    ...ClientBillingByPeriodFragment
                }
            }
        }
    }
}
`;
